import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCodeBox24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconCodeBox24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5 5.5h14A1.5 1.5 0 0 1 20.5 7v10a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 17V7A1.5 1.5 0 0 1 5 5.5M2 7a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm7.069 2.81a.75.75 0 0 0-1.061-1.06l-2.72 2.72-.53.53.53.53 2.72 2.72a.75.75 0 1 0 1.06-1.06L6.88 12zm5.862 0a.75.75 0 1 1 1.06-1.06l2.72 2.72.53.53-.53.53-2.72 2.72a.75.75 0 0 1-1.06-1.06l2.19-2.19zm-1.64-1.227a.75.75 0 0 1 .432.969l-2.082 5.422a.75.75 0 0 1-1.4-.538l2.081-5.422a.75.75 0 0 1 .97-.431"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCodeBox24);
